export default "__VITE_PUBLIC_ASSET__33bc20de__"